export const COLLAB_CLUB_SKILLS = [
  'Composer',
  'DJ',
  'Engineer',
  'Instrumentalist',
  'Producer',
  'Topliner',
  'Vocalist',
  'Writer',
];

export const COLLAB_CLUB_GENRES = [
  'Hiphop / Alt Hiphop',
  'Indian Pop',
  'Instrumental / Classical',
  'Jazz / Gospel',
  'Producer / Electronic',
  'Rock / Indie Rock',
  'Indie',
  'Reggae',
  'Pop / alt. pop',
  'Brazilian Rap',
  'Brazilian',
  'Afro',
  'Yoga',
  'Funk',
];

export const WORK_PREFERENCES = {
  remixes: 'Remixes/old releases',
  new: 'New releases',
  both: 'Both',
} as const;

export type WorkPreference = keyof typeof WORK_PREFERENCES;
